import { useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FormEvent, useState } from 'react'
import writeXlsxFile, { Row, SheetData } from 'write-excel-file'
import { get } from '../../../lib/http'
import extractDataForm from '../../../utilities/extractDataForm'

import { DataForm, ReportSalesByWaiter } from './types'

export default function usePrintSalesByWaiter() {
    const toast = useToast()
    const [isLoading, setIsLoading] = useState(false)

    const head: (...values: string[]) => Row[number][] = (...values) =>
        values.map<Row[number]>(val => ({
            value: val,
            fontWeight: 'bold',
            wrap: true,
            alignVertical: 'center',
            align: 'left',
            fontSize: 11
        }))

    function setDataSalesByWaiter(
        data: ReportSalesByWaiter[],
        rows: SheetData
    ) {
        data.forEach(item => {
            rows.push([
                {
                    value: item.waiter,
                    type: String
                },
                {
                    value: item.category,
                    type: String
                },
                {
                    value: item.product,
                    type: String
                },
                {
                    value: item.quantity,
                    type: Number
                },
                {
                    value: item.total,
                    type: Number,
                    align: 'right',
                    format: '#,##0.00'
                }
            ])
        })
    }

    async function submit(ev: FormEvent<HTMLFormElement>) {
        ev.preventDefault()
        const form = extractDataForm<DataForm>(ev.target)
        const startDate = dayjs
            .tz(form.startDate + ' 00:00:00', 'America/Lima')
            .toISOString()
        const endDate = dayjs
            .tz(form.endDate + ' 23:59:59', 'America/Lima')
            .toISOString()

        const rows: SheetData = [
            [],
            [
                {
                    value: 'Reporte de Ventas por Meser@',
                    fontWeight: 'bold',
                    span: 4,
                    alignVertical: 'center',
                    align: 'center',
                    fontSize: 16
                }
            ],
            [
                {
                    value: `De: ${dayjs(startDate).format(
                        'DD/MM/YYYY'
                    )} - Hasta ${dayjs(endDate).format('DD/MM/YYYY')}`,
                    span: 4,
                    align: 'center'
                }
            ],
            [],
            head(
                ...['Meser@', 'Categoría', 'Producto', 'Cantidad', 'Total (S/)']
            )
        ]

        setIsLoading(true)

        const { data, error } = await get<ReportSalesByWaiter[]>(
            `/api/reports/sales_by_waiter?start_date=${startDate}&end_date=${endDate}`
        )

        if (error) {
            toast({
                title: 'Hubo un error al cargar los datos',
                status: 'error',
                position: 'top'
            })
            return
        }

        setDataSalesByWaiter(data.result, rows)

        await writeXlsxFile(rows, {
            fileName: `Reporte_de_ventas_por_meser@_${dayjs(startDate).format(
                'DD/MM/YYYY'
            )}_${dayjs(endDate).format('DD/MM/YYYY')}.xlsx`,
            columns: [40, 40, 12, 12].map(width => ({
                width
            })),
            fontSize: 10,
            fontFamily: 'Calibri'
        })

        setIsLoading(false)
    }

    return {
        submit,
        isLoading
    }
}
